export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["BODY"] = "bodyStyleType";
    FilterTypes["FUEL"] = "fuelType";
    FilterTypes["GEARBOX"] = "transmissionType";
    FilterTypes["PRICE"] = "price";
    FilterTypes["SERIES_TYPE"] = "seriesType";
    FilterTypes["BODY_TYPE"] = "bodytypeType";
    FilterTypes["GROSS_WEIGHT_CAPACITY_TYPE"] = "grossWeightCapacityType";
    FilterTypes["MAXIMUM_POWER_TYPE"] = "maximumPowerType";
    FilterTypes["USABLE_CAB_TO_AXLE_TYPE"] = "usableCabToAxleType";
    FilterTypes["VEHICLE_GROSS_WEIGHT_TYPE"] = "vehicleGrossWeightType";
    FilterTypes["DIMENSIONS_FROM_WHEEL_TRACK_TYPE"] = "dimensionsFromWheelTrackType";
    FilterTypes["DIVISION"] = "division";
    FilterTypes["VEHICLE_IN_STOCK"] = "vehicleInStockType";
    FilterTypes["CITY"] = "city";
    FilterTypes["INTERIOR"] = "interior";
    FilterTypes["EXTERIOR"] = "exterior";
    FilterTypes["VARIANT"] = "variant";
})(FilterTypes || (FilterTypes = {}));
//# sourceMappingURL=FilterTypes.js.map